<section class="company-details-wrapper" [ngClass]="{ 'company-details-extension-wrapper': (isExtension || isMobile)}">
  <div class="wrapper" *ngIf="companyDetails; else loading">
    <div *ngIf="!isMobile" class="details-header">
      <div class="grid flex justify-content-between flex-wrap grid-nogutter">
        <div class="col align-items-center">
          <ul class="navigation">
            <!-- <li *ngIf="!isV2CompanyDetails">
              <a (click)="onCopyUrl()" tooltipPosition="bottom" placeholder="Bottom" pTooltip="Copy Url">
                <i class="pi pi-copy"></i>
              </a>
            </li> -->
            <ng-container *ngIf="authService.isInvestor || authService.isAdmin">
              <!-- Hiding -->
              <!-- <li *ngIf="companyDetails.priority === 0 || companyDetails.priority === 2">
                <a
                  (click)="onTopBarClick('addToPriority')"
                  [ngClass]="{ 'opacity-50': !isPartOfCoverageUsers }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Add to Priority"
                >
                  <span class="icon-add-priority"></span>
                </a>
              </li>

              <li *ngIf="companyDetails.priority === 3">
                <a
                  (click)="onTopBarClick('removeFromPriority')"
                  [ngClass]="{ 'opacity-50': !isPartOfCoverageUsers || !isCompanyActive }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Remove from priority"
                >
                  <span class="icon-remove-priority"></span>
                </a>
              </li> -->

              <!-- <li *ngIf="!isPartOfCoverageUsers">
                <a
                  (click)="onTopBarClick('joinCoverage')"
                  [pTooltip]="coverageBtnLabel"
                  [ngClass]="{ 'opacity-50': !isCompanyActive }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Join Coverage"
                >
                  <span class="icon-add-coverage"></span>
                </a>
              </li> -->

              <!-- <li>
                <a
                  (click)="onTopBarClick('changeStatus')"
                  [ngClass]="{ 'opacity-50': !isCompanyActive }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Change Status"
                >
                  <span class="icon-status"></span>
                </a>
              </li> -->
              <!-- <li>
                <a
                  (click)="onTopBarClick('leaveCoverage')"
                  [ngClass]="{ 'opacity-50': !isPartOfCoverageUsers || !isCompanyActive }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Leave Coverage"
                >
                  <span class="icon-remove-coverage"></span>
                </a>
              </li> -->
              <!-- <li>
                <a
                  (click)="onTopBarClick('editCoverage')"
                  [ngClass]="{ 'opacity-50': !isCompanyActive }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Edit Coverage"
                >
                  <span class="icon-edit"></span>
                </a>
              </li> -->
              <!-- <li>
                <a class="opacity-50" tooltipPosition="bottom" placeholder="Bottom" pTooltip="Create/Edit Alert">
                  <span class="icon-notification" (click)="onTopBarClick('createOrEditNotificationTrigger')"></span>
                </a>
              </li> -->
              <li>
                <a
                  (click)="onTopBarClick('flagForICVoting')"
                  [ngClass]="{ 'opacity-50': disableICVoting }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Flag for IC Voting"
                >
                  <span class="icon-thumbs-up"></span>
                </a>
              </li>
              <!-- enrich data icon is intentionally hidden for experimentation -->
              <!-- <li style="display: none;">
                <a
                  (click)="onTopBarClick('enrichData')"
                  [ngClass]="{ 'opacity-50': !enableEnrichment }"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="Enrich Data"
                >
                  <span class="icon-enrich"></span>
                </a>
              </li>
               -->
              <!-- Button hidden due to AI Prep being hidden -->
              <!-- <li>
                <a
                  (click)="onAISummaryClick()"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                  pTooltip="AI Generated Summary"
                >
                <i class="fa-regular fa-file-lines"></i>
                </a>
              </li> -->
            </ng-container>
            <!-- <li>
              <a (click)="supportIconClick($event)" href="{{ supportService.supportEmail() }}" tooltipPosition="bottom" placeholder="Bottom"
                pTooltip="Support" target="_blank">
                <span class="icon-mail"></span>
              </a>
            </li> -->
            <li>
              <a
              (click)="onTopBarClick('addToPortfolio')"
              tooltipPosition="bottom"
              placeholder="Bottom"
              pTooltip="Add To Portfolio"
              [ngClass]="{ 'opacity-50': !authService.isAdmin }"
              *ngIf="authService.isAdmin"
              >
              <span class="fa-regular fa-folder"></span>
              </a>
            </li>
            <li>
            <a
              (click)="downloadSpreadsheet()"
              *ngIf="authService.investmentcommitteeadmin && !isTablet"
              tooltipPosition="bottom"
              placeholder="Bottom"
              pTooltip="Download IC Voting Details"
            >
                <span class="fa-regular fa-circle-down"></span>
            </a>
          </li>
          </ul>
        </div>
        <div class="col flex-w-auto align-items-center">
          <ul class="navigation gap-16">
            <!-- <ng-container *ngIf="config.navigateThruCompanies && !isExtension && dataView == 'table'">
              <li>
                <a (click)="goToPrevious()" [ngClass]="{ 'opacity-50': !companiesNavigationEnabled }">
                  <span class="icon-circle-left"></span>
                </a>
              </li>
              <li>
                <a (click)="goToNext()" [ngClass]="{ 'opacity-50': !companiesNavigationEnabled }">
                  <span class="icon-circle-right"></span>
                </a>
              </li>
            </ng-container> -->
            <li *ngIf="!isExtension">
              <a (click)="close()">
                <i class="pi pi-times"></i>
              </a>
            </li>
            <li *ngIf="isExtension">
              <a (click)="openInJarvis()" tooltipPosition="bottom" placeholder="Bottom" pTooltip="Open in Jarvis">
                <span class="icon-exit"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div class="details-content" [ngClass]="{ 'details-content-mobile': isMobile}"  >
      <div class="grid grid-nogutter info-wrapper" style="margin-bottom: 2px">
        <div class="col extention-full-w">
          <div class="grid grid-no-tb-gutter">
            <div class="col flex-w-auto" *ngIf="!isMobile">
              <!-- <p-avatarGroup>
                <p-avatar
                  [overlayPanelTooltip]="scoreTooltip"
                  label="{{ companyDetails.rank | number : '1.0-0' }}"
                  styleClass="cyan w-38"
                  shape="circle"
                ></p-avatar>
              </p-avatarGroup> -->
              <!-- Company Score -->
              <!-- <p-overlayPanel  styleClass="tool-tip-class" #scoreTooltip>
                <bpc-company-score></bpc-company-score>
              </p-overlayPanel> -->
            </div>
            <div class="col">
              <h4 tabindex="0" id="company-name"></h4>
              <h2>
                <span class="icon-enrich mr-2" *ngIf="!enableEnrichment"></span>
                <p-overlayPanel #enrichmentStatusPanel>
                  {{ companyDetails.workflows | enrichmentStatus }}
                </p-overlayPanel>
                {{ companyDetails.name }}
              </h2>
              <!-- <p class="type" *ngIf="companyType">{{ companyType }}</p> -->
              <div style="display: flex; align-items: center;">
                <!-- Social Links -->
                <bpc-social-icon
                  *ngFor="let link of companyDetails | socialLinks"
                  class="social-links"
                  [socialLink]="link"
                  (urlClick)="socialUrlClick($event)"
                >
                </bpc-social-icon>
                <bpc-notifications-icon
                  (onClick)="emitCompanyAction('createOrEditNotificationTrigger')"
                  [company]="companyDetails"
                >
                </bpc-notifications-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="col flex-w-auto d-center extention-full-w">
          <div class="grid grid-no-tb-gutter flex justify-content-end">
            <!-- <div *ngIf="isExtension" class="col flex-w-auto">            
              <p-button (click)="openInJarvis()" styleClass="btn-accept mg-b-16" label="Open in Jarvis"></p-button>
            </div> -->
            <div *ngIf="canAcceptChanges" class="flex">
              <div class="col flex-w-auto">
                <p-button (click)="acceptChanges()" styleClass="btn-accept mg-b-16" label="Accept Changes"></p-button>
              </div>
              <div class="col flex-w-auto">
                <p-button
                  (click)="declineChanges()"
                  styleClass="btn-decline mg-b-16"
                  label="Decline Changes"
                ></p-button>
              </div>
            </div>
            <div class="col flex-w-auto" *ngIf="canMarkAsDone">
              <p-button (click)="markAsDone()" styleClass="btn-accept mg-b-16" label="Mark as Done"></p-button>
            </div>
          </div>

          <div class="grid" [ngClass]="{'info-header-container':isExtension || isMobile}">
            
            <!-- Source Scrub Exclusive -->
            <!-- <div *ngIf="companyDetails.foundDate" class="col flex-w-auto data-labels btm-space">
              <strong>Founded:</strong>{{ (companyDetails.foundDate | date : "yyyy") ?? "-" }}
            </div> -->
            
            <div *ngIf="companyDetails.address" class="col flex-w-auto data-labels btm-space">
              <strong>Location:</strong>{{ companyDetails.address | companyLocation }}
            </div>
          </div>
          <div class="grid">
            <!-- <div *ngIf="companyDetails.paidInCapital" class="col flex-w-auto data-labels btm-space">
              <strong>Total Raised:</strong>{{ companyDetails.paidInCapital | bpcNumber : "1.0-1" : "$" }}
            </div> -->
            <!-- <div *ngIf="companyDetails.latestRound?.amount" class="col flex-w-auto data-labels btm-space">
              <strong>Last Round:</strong> {{ companyDetails.latestRound?.amount | bpcNumber : "1.0-1" : "$" }}
            </div> -->
          </div>
          <!-- <div *ngIf="companyDetails.parentCompanyName?.name" class="grid">
            <div class="col data-labels" style="line-height: 150%;">
              <strong>Parent Company: </strong>{{ companyDetails.parentCompanyName?.name }}
            </div>
          </div> -->
          <!--
          <div *ngIf="authService.isInvestor || authService.isAdmin" class="grid" [ngClass]="{'info-header-container':isExtension || isMobile}">
            <div class="col flex-w-auto data-labels btm-space flex align-items-center gap-3" >
              <!-- <strong>Daily News Alerts:</strong>
              <p-inputSwitch name="weeklyNewsToggle" onLabel="On" offLabel="Off" (onChange)="handleSubscriptionChange($event)" [(ngModel)]="weeklySubscription">
              </p-inputSwitch> 
            </div>
          </div>-->
        </div>
      </div>
      <section class="columns-wrap">
        <!-- First Column -->
        <div class="first">
          <div class="grid grid-no-tb-gutter">
            <div class="col-12 label-tag" *ngIf="companyDetails.statusId != null">
              <div class="grid">
                <div class="col flex-w-auto flex align-items-center justify-content-center">
                  <strong>Status</strong>
                </div>
                <div class="col flex justify-content-end">
                  <div 
                  pTooltip="Edit Status" 
                  tooltipPosition="bottom"   
                  *ngIf="!isMobile"
                  style="background: #F5FAFF;; color: #FF6C39; border-width: 0px; border-radius: 100px; width: 34.2px; height: 34.2px; cursor: pointer;" (click)="emitCompanyAction('changeStatus')">
                  <svg class="svg-icon" style="width: 25px; height: 25px; vertical-align: middle; fill: #FF6C39; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M358.277408 561.800219c-0.596588 0.759293-1.193175 1.559519-1.461281 2.52245l-46.050826 168.836313c-2.685155 9.829879 0.065492 20.422122 7.342222 27.889187 5.442966 5.317099 12.614296 8.239662 20.252253 8.239662 2.52245 0 5.050016-0.301875 7.537673-0.962931l167.638021-45.722344c0.26913 0 0.399089 0.23536 0.601704 0.23536 1.925862 0 3.817955-0.700965 5.246491-2.161223l448.270537-448.205045c13.31526-13.332656 20.61655-31.494295 20.61655-51.254338 0-22.38994-9.496282-44.770669-26.126031-61.356416L919.809521 117.458155c-16.604166-16.629749-39.016619-26.143427-61.396325-26.143427-19.754926 0-37.915541 7.303336-51.264571 20.602224L358.944604 560.241724C358.478999 560.669466 358.609982 561.302893 358.277408 561.800219M923.791206 228.575906l-44.526099 44.49233-72.180949-73.327052 43.894719-43.895743c6.935969-6.973832 20.384259-5.956665 28.353768 2.041496l42.363853 42.402739c4.420683 4.41352 6.941086 10.289344 6.941086 16.099676C928.610978 221.151819 926.914336 225.473241 923.791206 228.575906M437.999101 568.842613l323.465043-323.483462 72.216765 73.376171-322.863339 322.847989L437.999101 568.842613 437.999101 568.842613zM379.065873 699.990558l23.375383-85.799108 62.352093 62.358233L379.065873 699.990558 379.065873 699.990558zM927.623487 406.192186c-16.968463 0-31.904641 13.796214-31.970132 30.994921l0 419.411255c0 21.913079-17.796318 38.907125-39.744189 38.907125L166.418752 895.505487c-21.914102 0-38.247092-16.991999-38.247092-38.907125L128.17166 166.360935c0-21.930475 16.331967-38.441521 38.247092-38.441521l473.184973 0c17.063631 0 30.908964-15.163351 30.908964-32.232099 0-17.034978-13.846356-31.68156-30.908964-31.68156L161.703357 64.005756c-53.42477 0-97.827049 44.216038-97.827049 97.67253l0 699.637518c0 53.458539 44.403303 98.422613 97.827049 98.422613l698.884364 0c53.463656 0 98.967012-44.964074 98.967012-98.422613l0-424.324148C959.489242 419.9884 944.587857 406.192186 927.623487 406.192186" />
                  </svg>                  
                </div>
                </div>
              </div>
              <p>{{ companyDetails.statusId | status }}</p>
              <!-- <div class="tags-wrap">
                <span class="tags">{{ companyDetails.statusId | status }}</span>
              </div> -->
            </div>
            <div class="col-12 label-tag" *ngIf="isExtension || isMobile">
              <div class="grid">
                <div class="col flex-w-auto flex align-items-center justify-content-center">
                  <strong>Tags</strong>
                </div>
                <div class="col-12">
                  <div class="tags-wrap" *ngIf="tags.length > 0; else noTags">
                    <bpc-custom-tag
                      *ngFor="let tag of tags | slice : 0 : 5; trackBy: trackByTag"
                      (tagClick)="onTagClick(tag)"
                      (editTagClick)="onEditTagClick(tag)"
                      (removeTagClick)="onRemoveTagClick(tag)"
                      [tag]="tag"
                    >
                    </bpc-custom-tag>
                    <button
                      pButton
                      id="{{ 'show-more-tags' }}"
                      title="Show More"
                      (click)="showMoreTags()"
                      *ngIf="tags.length > 5"
                      class="show-more"
                    >
                      Show more
                    </button>
                  </div>
                  <ng-template #noTags>
                    <p>No Tags found</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="col-12 label-tag" *ngIf="isExtension || isMobile">
              <div class="grid">
                <div class="col flex-w-auto flex align-items-center justify-content-center">
                  <strong>Investors</strong>
                </div>
                <div class="col-12">
                  <div class="tags-wrap" *ngIf="investors.length > 0; else noInvestors">
                    <span class="tags" *ngFor="let field of investors | slice : 0 : 10;">
                      <span>{{ field.name }}</span>
                    </span>
                    <button
                      pButton
                      id="{{ 'show-more-tags' }}"
                      title="Show More"
                      (click)="showMoreInvestors()"
                      *ngIf="investors.length > 5"
                      class="show-more"
                    >
                      Show more
                    </button>
                  </div>
                  <ng-template #noInvestors>
                    <p>No Investors found</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="col-12 label-tag">
              <!-- FINANCIALS  -->
              <div class="grid">
                <div class="col flex-w-auto flex align-items-center justify-content-center">
                  <strong>Financials</strong>
                </div>
                <div class="col flex justify-content-end">
                  <div 
                  pTooltip="Edit Financials" 
                  tooltipPosition="bottom"   
                  *ngIf="!isMobile"
                  style="background: #F5FAFF; cursor: pointer; border-color: #FF6C39; border-width: 0px; border-radius: 100px; width: 34.2px; height: 34.2px" (click)="emitCompanyAction('editFinancials')">
                  <svg class="svg-icon" style="width: 25px; height: 25px;  vertical-align: middle; fill: #FF6C39; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M358.277408 561.800219c-0.596588 0.759293-1.193175 1.559519-1.461281 2.52245l-46.050826 168.836313c-2.685155 9.829879 0.065492 20.422122 7.342222 27.889187 5.442966 5.317099 12.614296 8.239662 20.252253 8.239662 2.52245 0 5.050016-0.301875 7.537673-0.962931l167.638021-45.722344c0.26913 0 0.399089 0.23536 0.601704 0.23536 1.925862 0 3.817955-0.700965 5.246491-2.161223l448.270537-448.205045c13.31526-13.332656 20.61655-31.494295 20.61655-51.254338 0-22.38994-9.496282-44.770669-26.126031-61.356416L919.809521 117.458155c-16.604166-16.629749-39.016619-26.143427-61.396325-26.143427-19.754926 0-37.915541 7.303336-51.264571 20.602224L358.944604 560.241724C358.478999 560.669466 358.609982 561.302893 358.277408 561.800219M923.791206 228.575906l-44.526099 44.49233-72.180949-73.327052 43.894719-43.895743c6.935969-6.973832 20.384259-5.956665 28.353768 2.041496l42.363853 42.402739c4.420683 4.41352 6.941086 10.289344 6.941086 16.099676C928.610978 221.151819 926.914336 225.473241 923.791206 228.575906M437.999101 568.842613l323.465043-323.483462 72.216765 73.376171-322.863339 322.847989L437.999101 568.842613 437.999101 568.842613zM379.065873 699.990558l23.375383-85.799108 62.352093 62.358233L379.065873 699.990558 379.065873 699.990558zM927.623487 406.192186c-16.968463 0-31.904641 13.796214-31.970132 30.994921l0 419.411255c0 21.913079-17.796318 38.907125-39.744189 38.907125L166.418752 895.505487c-21.914102 0-38.247092-16.991999-38.247092-38.907125L128.17166 166.360935c0-21.930475 16.331967-38.441521 38.247092-38.441521l473.184973 0c17.063631 0 30.908964-15.163351 30.908964-32.232099 0-17.034978-13.846356-31.68156-30.908964-31.68156L161.703357 64.005756c-53.42477 0-97.827049 44.216038-97.827049 97.67253l0 699.637518c0 53.458539 44.403303 98.422613 97.827049 98.422613l698.884364 0c53.463656 0 98.967012-44.964074 98.967012-98.422613l0-424.324148C959.489242 419.9884 944.587857 406.192186 927.623487 406.192186" />
                  </svg>   
                </div>
                </div>
              </div>
              <p class="mgr-0" *ngIf="companyDetails.targetFinancials; else noTargetFinancials">
                <!-- SourceScrub exclusive -->
                {{ companyDetails.targetFinancials }}
                <!-- {{ companyType ? companyType + " / " : "" }}{{ companyDetails.targetFinancials }} -->
              </p>
              <ng-template #noTargetFinancials>
                <!-- SourceScrub exclusive -->
                <p>No data available</p>
                <!-- <p>{{ companyType ? companyType + " / " : "" }}No data available</p> -->
              </ng-template>
            </div>

            <ng-container *ngIf="companyDetails.statusId === 13">
              <div class="col-12 label-tag">
                <div class="grid">
                  <div class="col flex-w-auto flex align-items-center justify-content-center">
                    <strong>Next Step</strong>
                  </div>
                  <div class="col flex justify-content-end">
                    <div 
                    pTooltip="Edit Next Step" 
                    tooltipPosition="bottom"   
                    *ngIf="!isMobile"
                    style="background: #F5FAFF;; border-color: #FF6C39; cursor: pointer; border-width: 0px; border-radius: 100px; width: 34.2px; height: 34.2px" (click)="emitCompanyAction('editNextStep')">
                    <svg class="svg-icon" style="width: 25px; height: 25px;  vertical-align: middle; fill: #FF6C39; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <path d="M358.277408 561.800219c-0.596588 0.759293-1.193175 1.559519-1.461281 2.52245l-46.050826 168.836313c-2.685155 9.829879 0.065492 20.422122 7.342222 27.889187 5.442966 5.317099 12.614296 8.239662 20.252253 8.239662 2.52245 0 5.050016-0.301875 7.537673-0.962931l167.638021-45.722344c0.26913 0 0.399089 0.23536 0.601704 0.23536 1.925862 0 3.817955-0.700965 5.246491-2.161223l448.270537-448.205045c13.31526-13.332656 20.61655-31.494295 20.61655-51.254338 0-22.38994-9.496282-44.770669-26.126031-61.356416L919.809521 117.458155c-16.604166-16.629749-39.016619-26.143427-61.396325-26.143427-19.754926 0-37.915541 7.303336-51.264571 20.602224L358.944604 560.241724C358.478999 560.669466 358.609982 561.302893 358.277408 561.800219M923.791206 228.575906l-44.526099 44.49233-72.180949-73.327052 43.894719-43.895743c6.935969-6.973832 20.384259-5.956665 28.353768 2.041496l42.363853 42.402739c4.420683 4.41352 6.941086 10.289344 6.941086 16.099676C928.610978 221.151819 926.914336 225.473241 923.791206 228.575906M437.999101 568.842613l323.465043-323.483462 72.216765 73.376171-322.863339 322.847989L437.999101 568.842613 437.999101 568.842613zM379.065873 699.990558l23.375383-85.799108 62.352093 62.358233L379.065873 699.990558 379.065873 699.990558zM927.623487 406.192186c-16.968463 0-31.904641 13.796214-31.970132 30.994921l0 419.411255c0 21.913079-17.796318 38.907125-39.744189 38.907125L166.418752 895.505487c-21.914102 0-38.247092-16.991999-38.247092-38.907125L128.17166 166.360935c0-21.930475 16.331967-38.441521 38.247092-38.441521l473.184973 0c17.063631 0 30.908964-15.163351 30.908964-32.232099 0-17.034978-13.846356-31.68156-30.908964-31.68156L161.703357 64.005756c-53.42477 0-97.827049 44.216038-97.827049 97.67253l0 699.637518c0 53.458539 44.403303 98.422613 97.827049 98.422613l698.884364 0c53.463656 0 98.967012-44.964074 98.967012-98.422613l0-424.324148C959.489242 419.9884 944.587857 406.192186 927.623487 406.192186" />
                    </svg>   
                  </div>
                  </div>
                </div>
                <p *ngIf="companyDetails?.nextStep; else noNextStep">
                  {{ companyDetails.nextStep }}
                </p>
                <ng-template #noNextStep>
                  <p>No data available</p>
                </ng-template>
              </div>
            </ng-container>

            <div class="col-12 label-tag extention-full-w-50">
              <div class="grid">
                <div class="col flex-w-auto flex align-items-center justify-content-center">
                  <strong>Coverage</strong>
                </div>
                <div class="col flex justify-content-end">
                  <div 
                  pTooltip="Edit Coverage" 
                  tooltipPosition="bottom"   
                  *ngIf="!isMobile"
                  style="background: #F5FAFF;; cursor: pointer; border-color: #FF6C39; border-width: 0px; border-radius: 100px; width: 34.2px; height: 34.2px" (click)="emitCompanyAction('editCoverage')">
                  <svg class="svg-icon" style="width: 25px; height: 25px;  vertical-align: middle; fill: #FF6C39; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M358.277408 561.800219c-0.596588 0.759293-1.193175 1.559519-1.461281 2.52245l-46.050826 168.836313c-2.685155 9.829879 0.065492 20.422122 7.342222 27.889187 5.442966 5.317099 12.614296 8.239662 20.252253 8.239662 2.52245 0 5.050016-0.301875 7.537673-0.962931l167.638021-45.722344c0.26913 0 0.399089 0.23536 0.601704 0.23536 1.925862 0 3.817955-0.700965 5.246491-2.161223l448.270537-448.205045c13.31526-13.332656 20.61655-31.494295 20.61655-51.254338 0-22.38994-9.496282-44.770669-26.126031-61.356416L919.809521 117.458155c-16.604166-16.629749-39.016619-26.143427-61.396325-26.143427-19.754926 0-37.915541 7.303336-51.264571 20.602224L358.944604 560.241724C358.478999 560.669466 358.609982 561.302893 358.277408 561.800219M923.791206 228.575906l-44.526099 44.49233-72.180949-73.327052 43.894719-43.895743c6.935969-6.973832 20.384259-5.956665 28.353768 2.041496l42.363853 42.402739c4.420683 4.41352 6.941086 10.289344 6.941086 16.099676C928.610978 221.151819 926.914336 225.473241 923.791206 228.575906M437.999101 568.842613l323.465043-323.483462 72.216765 73.376171-322.863339 322.847989L437.999101 568.842613 437.999101 568.842613zM379.065873 699.990558l23.375383-85.799108 62.352093 62.358233L379.065873 699.990558 379.065873 699.990558zM927.623487 406.192186c-16.968463 0-31.904641 13.796214-31.970132 30.994921l0 419.411255c0 21.913079-17.796318 38.907125-39.744189 38.907125L166.418752 895.505487c-21.914102 0-38.247092-16.991999-38.247092-38.907125L128.17166 166.360935c0-21.930475 16.331967-38.441521 38.247092-38.441521l473.184973 0c17.063631 0 30.908964-15.163351 30.908964-32.232099 0-17.034978-13.846356-31.68156-30.908964-31.68156L161.703357 64.005756c-53.42477 0-97.827049 44.216038-97.827049 97.67253l0 699.637518c0 53.458539 44.403303 98.422613 97.827049 98.422613l698.884364 0c53.463656 0 98.967012-44.964074 98.967012-98.422613l0-424.324148C959.489242 419.9884 944.587857 406.192186 927.623487 406.192186" />
                  </svg>   
                </div>
                </div>
              </div>
              <ng-template [ngIf]="coverageUsers">
                <p-avatarGroup>
                  <p-avatar
                    *ngFor="let user of coverageUsers | slice : 0 : 3"
                    [overlayPanelTooltip]="userNameTooltip"
                    label="{{ user?.name ?? '' | initials }}"
                    size="large"
                    styleClass="cyan cursor-pointer"
                    shape="circle"
                  >
                    <p-overlayPanel styleClass="tool-tip-class" #userNameTooltip>
                      <p>{{ user?.name ?? "" }}</p>
                    </p-overlayPanel>
                  </p-avatar>
                  <p-avatar
                    styleClass="grey"
                    *ngIf="coverageUsers.length > 3"
                    size="large"
                    shape="circle"
                    [overlayPanelTooltip]="allUserNameTooltip"
                    >+{{ coverageUsers.length - 3 }}
                  </p-avatar>
                </p-avatarGroup>

                <p-overlayPanel styleClass="tool-tip-class" #allUserNameTooltip>
                  <p *ngFor="let user of coverageUsers">{{ user?.name ?? "" }}</p>
                </p-overlayPanel>

                <!-- <p *ngFor="let user of coverageUsers">{{ user?.name ?? "" }}</p> -->
              </ng-template>
              <ng-template [ngIf]="!coverageUsers">
                <p>None</p>
              </ng-template>
              <!-- <ng-container *ngIf="(authService.isInvestor || authService.isAdmin) && !isMobile">
                <div class="padd-tb-12" *ngIf="!isPartOfCoverageUsers">
                  <button 
                  pButton
                  tooltipPosition="bottom"   
                  style="background: white; border-color: #FF6C39; border-width: 0px; border-radius: 100px; width: 34.2px; height: 34.2px" 
                  (click)="onCoverageButtonClick('joinCoverage')" 
                  pTooltip="Join Coverage">
                    <i class="pi pi-plus"></i>
                  </button>
                </div>
              </ng-container> -->
            </div>

            <!-- Pod leader -->
            <div class="col-12 label-tag extention-full-w-50">
              <strong>Pod leader</strong>
              <p *ngIf="podLeader">
                {{ podLeader.name }}
              </p>
              <!-- <div *ngIf=" Leader" class="tags-wrap">
                <span class="tags">{{ podLeader.name }}</span>
              </div> -->
              <ng-template [ngIf]="!podLeader">
                <span>None</span>
              </ng-template>
            </div>

            <!-- Exclusive to sourcescrub -->
            <!-- INDUSTRY -->
            <!-- <div class="col-12 label-tag" *ngIf="companyDetails.industries.length > 0">
              <strong>Industry</strong>
              <p *ngFor="let sector of companyDetails.industries | companySectors">{{ sector }}</p>
            </div> -->

            <!-- Exclusive to sourcescrub -->
            <!-- INVESTORS  -->
            <!-- <div class="col-12 label-tag" *ngIf="companyDetails.investors.length > 0">
              <strong>Investor</strong>
              <p
                class="investor-label"
                *ngFor="let investor of companyDetails.investors; let i = index"
                (click)="(isExtension || isMobile) ? null : onInvestorClick(investor)"
              >
                {{ investor.name }}
              </p>
            </div> -->
          </div>
        </div>

        <!-- Second Column -->
        <div class="second">
          <!-- "activeIndex===0" are added for making performance good otherwise the app may crash -->
          <p-tabView styleClass="details-tabs" [(activeIndex)]="activeIndex" (onChange)="onTabViewClick()">
            <p-tabPanel header="Overview">
              <div class="grid">
                <div class="col-12">
                  <p class="overview">
                    {{ companyDetails.description }}
                  </p>
                </div>
                <!-- <div class="col-12">
                  <bpc-activity-data id="activity-data" [_companyDetails]="companyDetails" *ngIf="activeIndex === 0">
                  </bpc-activity-data>
                </div> -->
                <div class="col-12 mg-t-20">
                  <!-- <strong>Last Interaction</strong>
                  <bpc-interaction-history
                    id="activity-data"
                    [companyDetails]="companyDetails"
                    [interactions]="companyDetails.latestInteraction ? [companyDetails.latestInteraction] : []"
                  >
                  </bpc-interaction-history> -->
                  <div class="grid grid-no-tb-gutter flex justify-content-end align-items-center pb-2 pr-3">
                    <strong>Notes</strong>
                    <div class="col flex justify-content-end mb-10">
                      <button 
                      pButton
                      pTooltip="Add New Note" 
                      tooltipPosition="bottom"   
                      *ngIf="!isMobile"
                      style="
                        background: #F5FAFF; 
                        border-color: #FF6C39; 
                        border-width: 2px; 
                        border-radius: 4px; 
                        width: 23px; 
                        height: 23px; 
                        padding: 0; 
                        min-width: unset;
                      "
                      (click)="emitCompanyAction('addNote')">
                      <i class="pi pi-plus" style="font-size: 10px;"></i>
                    </button>
                    </div>
                  </div>
                  <bpc-interaction-history
                    id="activity-data"
                    [companyDetails]="companyDetails"
                    [interactions]=" getNotes() ?? []"
                    >
                  </bpc-interaction-history>
                </div>
              </div>
            </p-tabPanel>
            <!-- Exclusive to sourcescrub -->
             <!-- Updated active indexes as well -->
            <!-- <p-tabPanel header="Funding">
              <bpc-company-pic-data
                id="activity-data"
                [companyDetails]="companyDetails"
                *ngIf="activeIndex === 1"
              ></bpc-company-pic-data>
              <ng-template [ngIf]="editModeConnections">
                <bpc-relationship-data
                  (editConnections)="onEditConnections($event)"
                  (markChangesAsDone)="markAsDone()"
                  [companyDetails]="companyDetails"
                  [isExtension]="isExtension || isMobile"
                >
                </bpc-relationship-data>
              </ng-template>
              <p></p>
            </p-tabPanel> -->

            <p-tabPanel header="Contacts">
              <div class="grid">
                <div class="col-12">
                  <bpc-relationship-data
                    *ngIf="activeIndex === 1"
                    id="relationship"
                    (editConnections)="onEditConnections($event)"
                    (toggleCompanyNavigation)="onToggleCompanyNavigation($event)"
                    [companyDetails]="companyDetails"
                    [isExtension]="isExtension  || isMobile"
                  >
                  </bpc-relationship-data>
                </div>
              </div>

              <bpc-notifications-icon
                (onClick)="emitCompanyAction('createOrEditNotificationTrigger')"
                [company]="companyDetails"
              >
              </bpc-notifications-icon>
            </p-tabPanel>
            <p-tabPanel header="Interaction History">
              <div #historyData>
                <bpc-interaction-history
                  id="activity-data"
                  [companyDetails]="companyDetails"
                  *ngIf="activeIndex === 2"
                  [activeIndex]="activeIndex"
                  [interactions]="companyDetails.interactions ?? []"
                  (showAddDcInteractionsPopup)="showAddDcInteractionsPopup()"
                >
                </bpc-interaction-history>
              </div>
            </p-tabPanel>
          </p-tabView>

          <!-- Product Score -->

          <!-- <div *ngIf="g2ProductScores" class="mb-2">
            <bpc-product-score [productScore]="g2ProductScores"> </bpc-product-score>
          </div> -->

          <!-- 
          <div class="cd-st">
            <span class="cd-label">INVESTORS</span>
            <div class="cd-s-slot" style="max-height: 200px; overflow-y: scroll">
              <span *ngFor="let investor of companyDetails.investors" class="font-semibold md:font-normal">
                {{ investor.name }}
              </span>
            </div>
          </div>
          <div class="cd-st">
            <div class="cd-s-slot">
              <span class="cd-label">TOTAL RAISED</span>
              <span class="font-semibold md:font-normal">{{
                companyDetails.paidInCapital | bpcNumber : "1.0-1" : "$"
              }}</span>
              <span class="cd-label">LATEST ROUND</span>
              <span
                >{{ companyDetails.latestRound?.amount | bpcNumber : "1.0-1" : "$" }}
                {{ companyDetails.latestRound?.raiseDate | date : "MM/'yy" }}</span
              >
            </div>
          </div> -->
        </div>

        <!-- Third Column -->
        <div class="third" *ngIf="!(isExtension || isMobile)">
          <div class="grid grid-no-tb-gutter">
            <div class="col flex-w-auto flex align-items-center justify-content-center">
              <strong>Tags</strong>
            </div>
            <div class="col flex justify-content-end mb-10">
              <button 
              pButton
              pTooltip="Add New Tag" 
              tooltipPosition="bottom"   
              *ngIf="!isMobile"
              style="
                background: #F5FAFF; 
                border-color: #FF6C39; 
                border-width: 2px; 
                border-radius: 4px; 
                width: 23px; 
                height: 23px; 
                padding: 0; 
                min-width: unset;
                margin-right: 0.4rem !important;
              "
              (click)="openCreateNewTagModal()">
              <i class="pi pi-plus" style="font-size: 10px;"></i>
            </button>
            </div>
            <div class="col-12" *ngIf="tags.length > 0; else noTags">
              <div class="tags-wrap">
                <bpc-custom-tag
                  *ngFor="let tag of tags | slice : 0 : 10; trackBy: trackByTag"
                  (tagClick)="onTagClick(tag)"
                  (editTagClick)="onEditTagClick(tag)"
                  (removeTagClick)="onRemoveTagClick(tag)"
                  [tag]="tag"
                >
                </bpc-custom-tag>
                <button
                  pButton
                  id="{{ 'show-more-tags' }}"
                  title="Show More"
                  (click)="showMoreTags()"
                  *ngIf="tags.length > 10"
                >
                  Show more
                </button>
              </div>
            </div>
            <ng-template #noTags>
              <div class="col-12 mg-t-20">
                <p>No Tags found</p>
              </div>
            </ng-template>
          </div>
          <div class="grid grid-no-tb-gutter">
            <div class="col flex-w-auto flex align-items-center justify-content-center">
              <strong>Investors</strong>
            </div>
            <div class="col flex justify-content-end mb-10">
              <div 
              pTooltip="Edit Investors" 
              tooltipPosition="bottom"
              *ngIf="!isMobile"
              (click)="emitCompanyAction('editInvestors')"
              style="
                background: #F5FAFF;
                border: 0px solid #FF6C39;
                width: 34.2px;
                height: 34.2px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              ">
              <svg class="svg-icon" style="width: 25px; height: 25px;  vertical-align: middle; fill: #FF6C39; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M358.277408 561.800219c-0.596588 0.759293-1.193175 1.559519-1.461281 2.52245l-46.050826 168.836313c-2.685155 9.829879 0.065492 20.422122 7.342222 27.889187 5.442966 5.317099 12.614296 8.239662 20.252253 8.239662 2.52245 0 5.050016-0.301875 7.537673-0.962931l167.638021-45.722344c0.26913 0 0.399089 0.23536 0.601704 0.23536 1.925862 0 3.817955-0.700965 5.246491-2.161223l448.270537-448.205045c13.31526-13.332656 20.61655-31.494295 20.61655-51.254338 0-22.38994-9.496282-44.770669-26.126031-61.356416L919.809521 117.458155c-16.604166-16.629749-39.016619-26.143427-61.396325-26.143427-19.754926 0-37.915541 7.303336-51.264571 20.602224L358.944604 560.241724C358.478999 560.669466 358.609982 561.302893 358.277408 561.800219M923.791206 228.575906l-44.526099 44.49233-72.180949-73.327052 43.894719-43.895743c6.935969-6.973832 20.384259-5.956665 28.353768 2.041496l42.363853 42.402739c4.420683 4.41352 6.941086 10.289344 6.941086 16.099676C928.610978 221.151819 926.914336 225.473241 923.791206 228.575906M437.999101 568.842613l323.465043-323.483462 72.216765 73.376171-322.863339 322.847989L437.999101 568.842613 437.999101 568.842613zM379.065873 699.990558l23.375383-85.799108 62.352093 62.358233L379.065873 699.990558 379.065873 699.990558zM927.623487 406.192186c-16.968463 0-31.904641 13.796214-31.970132 30.994921l0 419.411255c0 21.913079-17.796318 38.907125-39.744189 38.907125L166.418752 895.505487c-21.914102 0-38.247092-16.991999-38.247092-38.907125L128.17166 166.360935c0-21.930475 16.331967-38.441521 38.247092-38.441521l473.184973 0c17.063631 0 30.908964-15.163351 30.908964-32.232099 0-17.034978-13.846356-31.68156-30.908964-31.68156L161.703357 64.005756c-53.42477 0-97.827049 44.216038-97.827049 97.67253l0 699.637518c0 53.458539 44.403303 98.422613 97.827049 98.422613l698.884364 0c53.463656 0 98.967012-44.964074 98.967012-98.422613l0-424.324148C959.489242 419.9884 944.587857 406.192186 927.623487 406.192186" />
              </svg>
              </div>
            </div>
            <div class="col-12" *ngIf="investors.length > 0; else noInvestors">
              <div class="tags-wrap">
                <span class="tags" *ngFor="let field of investors | slice : 0 : 10;">
                  <span>{{ field.name }}</span>
                </span>
                <button
                  pButton
                  id="{{ 'show-more-investors' }}"
                  title="Show More"
                  (click)="showMoreInvestors()"
                  *ngIf="investors.length > 10"
                >
                  Show more
                </button>
              </div>
            </div>
            <ng-template #noInvestors>
              <div class="col-12 mg-t-20">
                <p>No Investors found</p>
              </div>
            </ng-template>
          </div>
        </div>
      </section>
      <span *ngIf="isSafari" class="bottom-spacing"></span>
    </div>
  </div>
  <bpc-extension-preview
    *ngIf="!isExtension && companyDetails"
    #extensionPreview
    [companyDomain]="companyDetails?.domain"
  ></bpc-extension-preview>

  <ng-template #loading>
    <div class="wrapper">
      <div class="details-header" *ngIf="!(isExtension || isMobile)"></div>
      <div class="details-content loader-text-content" [ngClass]="{ 'loader-text-content-extension': (isExtension || isMobile)}">
        <div class="extension-loader">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          <p>Loading company details....</p>
        </div>
      </div>
    </div>
  </ng-template>
</section>
<!-- End Company Details -->



<p-toast key="cd" position="bottom-center"></p-toast>

<bpc-custom-modal (onHide)="resetTags()" [visible]="displayEditCustomTag">
  <ng-container modal-header>
    <span class="p-dialog-title" [innerHtml]="editTagHeader"><i class="fa-solid fa-tag mr-2"></i></span>
  </ng-container>
  <ng-container modal-content>
    <bpc-edit-custom-tag
      *ngIf="displayEditCustomTag && companyDetails"
      [mode]="editCustomTagMode"
      [company]="companyDetails"
      [isBulk]="false"
      [(selectedCompanies)]="selectedTagCompanies"
      [(tag)]="tag"
    >
    </bpc-edit-custom-tag>
  </ng-container>
  <ng-container modal-footer>
    <button
      *ngIf="editCustomTagMode === 'edit' && tag.createBy === user?.id"
      pButton
      class="mr-2"
      (click)="deleteTag()"
    >
      Delete Tag from Jarvis
    </button>
    <button pButton class="mr-2" (click)="resetTags()">Cancel</button>
    <button
      pButton
      class="button-dark"
      type="submit"
      (click)="saveTag()"
      [disabled]="savingTags || !tag.name || !tag.name.length"
    >
      Save
    </button>
  </ng-container>
</bpc-custom-modal>

<bpc-custom-modal (onHide)="displayTagsModal = false" [visible]="displayTagsModal" [contentStyleClass]="'scrollable'">
  <ng-container modal-header>
    <span class="text-xl font-bold">Tags</span>
    <i class="pi pi-times cursor-pointer" (click)="displayTagsModal = false"></i>
  </ng-container>
  <ng-container modal-content>
    <div class="tags-wrap" *ngIf="tags.length > 0; else noTags">
      <bpc-custom-tag
        *ngFor="let tag of tags; trackBy: trackByTag"
        (tagClick)="onTagClick(tag)"
        (editTagClick)="onEditTagClick(tag)"
        (removeTagClick)="onRemoveTagClick(tag)"
        [tag]="tag"
      >
      </bpc-custom-tag>
    </div>
    <ng-template #noTags>
      <p>No Tags found</p>
    </ng-template>
  </ng-container>
</bpc-custom-modal>
<bpc-custom-modal (onHide)="displayInvestorsModal = false" [visible]="displayInvestorsModal" [contentStyleClass]="'scrollable'">
  <ng-container modal-header>
    <span class="text-xl font-bold">Investors</span>
    <i class="pi pi-times cursor-pointer" (click)="displayInvestorsModal = false"></i>
  </ng-container>
  <ng-container modal-content>
    <div class="tags-wrap" *ngIf="investors.length > 0; else noInvestors">
      <span class="tags" *ngFor="let field of investors">
        <span>{{ field.name }}</span>
      </span>
    </div>
    <ng-template #noInvestors>
      <p>No Investors found</p>
    </ng-template>
  </ng-container>
</bpc-custom-modal>